import React, { useEffect, useState } from "react";
import Table from "../../Table/Table";
import Modal from "../Modal/Modal";
import style from "./TransactionHistoryModal.module.scss";
import { useSelector } from "react-redux";
import { format } from "date-fns";
import { formatPrice } from "../../../../utils/utils";
import Pagination from "../../Pagination/Pagination";
import Commonpagination from "../../Pagination/Commonpagination";

const TransactionHistoryModal = ({
  show,
  handleClose,
  page,
  setPage,
  userLedger,
  setSelectedWallet,
}) => {
  const optionsFieds = [
    { label: "Txn Id" },
    { label: "Amount [USD STBL]" },
    { label: "Type" },
    { label: "Status" },
    { label: "Date" },
  ];

  useEffect(() => {
  }, [userLedger]);

  return (
    <>
      <Modal
        show={show}
        handleClose={() => {
          handleClose();
          setSelectedWallet("");
        }}
        title="Transaction History"
        className={style.transactionmodal}
      >
        <Table
          noRecordContent={
            "It looks like you're just getting started on your investment journey."
          }
          fields={optionsFieds}
          className={style.table}
        >
          {userLedger?.totalItems > 0 ? (
            userLedger?.list?.map((item, index) => (
              <tr key={index}>
                <td>
                  {item?.transaction_id.length > 19
                    ? item?.transaction_id?.slice(0, 5) +
                      "..." +
                      item?.transaction_id?.slice(-5)
                    : item?.transaction_id}
                </td>
                <td> <div className={style.price_text}> {formatPrice(Number(item?.amount))} 
                </div></td>
                <td>{item?.transaction_type}</td>
                <td>{item?.transaction_status}</td>
                <td>{format(new Date(item?.created_at), "dd MMM, yyyy")}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td style={{ textAlign: "center" }} colSpan={5}>
                No records found!
              </td>
            </tr>
          )}
        </Table>
        {/* {ledger?.list?.length > 10 && ( */}
        <Commonpagination
          className={style.pagination}
          currentPage={page}
          totalPages={userLedger.totalPages}
          handlePageChange={(selected) => {
            setPage(selected);
          }}
        />
        {/* )} */}
      </Modal>
    </>
  );
};

export default TransactionHistoryModal;
